import React, { useState } from "react";
import {
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Tag,
  TagLabel,
  Button,
  Flex,
  Box,
  Stepper,
  Step,
  StepIndicator,
  StepStatus,
  StepIcon,
  StepNumber,
  StepSeparator,
  Badge
} from "@chakra-ui/react";
import { useAppContext } from "../../../contexts/AppContext";

const stepsLabels = ["1", "2", "3", "4"];
// Function to format the date in DD/MM/YYYY format
const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const OnboardingFundTable = ({ data }) => {
  const { tableSize } = useAppContext();
  const [category, setCategory] = useState("inProgress");

  // Filter data based on the selected category
  const filteredData = data.filter((fund) => fund.category === category);

  return (
    <>
      <Flex
        id="filters"
        w={{ lg: "fit-content", base: "100vw" }}
        overflowX={"auto"}
        flexWrap={"nowrap"}
        style={{ scrollbarWidth: "none" }}
        mx={{ lg: 0, base: -8 }}
        px={{ lg: 0, base: 8 }}>
        <Flex w={"fit-content"} p={1} bg={"grey.100"} borderRadius={8}>
          <Button
            onClick={() => setCategory("inProgress")}
            bg={category === "inProgress" ? "white" : "transparent"}
            color={category === "inProgress" ? "brand.700" : "grey.500"}
            fontWeight={"500"}
            _hover={{ color: "grey.700" }}>
            In Progress
          </Button>
          <Button
            onClick={() => setCategory("archived")}
            bg={category === "archived" ? "white" : "transparent"}
            color={category === "archived" ? "brand.700" : "grey.500"}
            fontWeight={"500"}
            _hover={{ color: "grey.700" }}>
            Archived
          </Button>
        </Flex>
      </Flex>

      <TableContainer>
        <Table variant="simple" size={tableSize}>
          <Thead>
            <Tr>
              <Th>Subfund</Th>
              <Th>Fund</Th>
              <Th>Investment strategy</Th>
              <Th>Creation date</Th>
              <Th>Status</Th>
              <Th>Onboarding progress</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredData.map((fund, index) => (
              <Tr key={index}>
                <Td fontWeight={"500"}>{fund.fundName}</Td>
                <Td><Tag colorScheme="brand">{fund.parentFund}</Tag></Td>
                <Td>
                <Tag gap={1}>
                    <Box
                      as="span"
                      bg={fund.investmentStrategy.color}
                      h="6px"
                      w="6px"
                      borderRadius={"full"}>

                      </Box>
                    <TagLabel>{fund.investmentStrategy.name}</TagLabel>
                </Tag>
              </Td>
              <Td><Badge colorScheme="">{formatDate(fund.creationDate)}</Badge></Td>
                <Td>
                  <Tag colorScheme={fund.status.color}>
                    <TagLabel>{fund.status.label}</TagLabel>
                  </Tag>
                </Td>
                <Td>
                  <Box width="200px">
                    <Stepper size="sm" colorScheme="brand" index={fund.step - 1}>
                      {stepsLabels.map((label, idx) => (
                        <Step key={idx} isCompletedStep={idx < fund.step - 1} isActiveStep={idx === fund.step - 1}>
                          <StepIndicator>
                          <StepStatus
                            complete={<StepIcon />}
                            incomplete={<StepNumber />}
                            active={<StepNumber />}
                            />
                          </StepIndicator>
                          <StepSeparator />
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
};

export default OnboardingFundTable;
